import connection from './connection.js'

const updateStatus = async function (id, status, callback) {
  const url = '/admin/recommend/update/status'
  let {
    error,
    data
  } = await connection.update(url, {
    id: id,
    status: status
  })
  if (callback) callback(error, data)
}

const topList = async function (callback) {
  const url = '/admin/recommend/top/list'
  let {
    error,
    data
  } = await connection.query(url)
  if (callback) callback(error, data)
}

export default {
  updateStatus: updateStatus,
  topList: topList
}
